import { render, staticRenderFns } from "./CharacterBasisEditor.vue?vue&type=template&id=af4e84c8&lang=pug&"
import script from "./CharacterBasisEditor.vue?vue&type=script&lang=js&"
export * from "./CharacterBasisEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterBasisEditor.vue"
export default component.exports